import { stdObject } from "../../../../data/types/stdObject";
import { writeAccountingReport } from "./writeAccountingReport";
import { writeCommmReport } from "./writeCommmReport";
import { writeDataResults } from "./writeDataResults";
import { writeMovementsBatches } from "./writeMovementsBatches";
import { writeMovementsProfit } from "./writeMovementsProfit";
import { writeMovementsReport } from "./writeMovementsReport";
import { writeRecordsReport } from "./writeRecordsReport";
import { writeSalesReport } from "./writeSalesReport";

export const writeResponseReport = async ({
  t,
  user,
  id,
  itemsList,
  tempValues,
  responseReportData,
  vPayments,
  cPayments,
  openWindow,
  setMsg,
  setModalData,
  closeMsg,
  reverseComm,
}: stdObject) => {
  let data: stdObject = {};
  switch (id) {
    case "D1":
      data = writeSalesReport({
        t,
        user,
        id,
        searchValues: tempValues,
        responseReportData,
        vPayments,
      });
      break;
    case "D2":
      data = writeCommmReport({
        t,
        user,
        id,
        searchValues: tempValues,
        responseReportData,
        openWindow,
        setMsg,
        setModalData,
        closeMsg,
        reverseComm,
      });
      break;
    case "D6":
      data = writeAccountingReport({
        t,
        id,
        searchValues: tempValues,
        responseReportData,
        vPayments,
        cPayments,
      });
      break;
    case "D11":
      data = writeMovementsProfit({
        t,
        id,
        searchValues: tempValues,
        responseReportData,
        vPayments,
        cPayments,
      });
      break;
    case "D12":
      data = writeRecordsReport({
        t,
        id,
        searchValues: tempValues,
        responseReportData,
      });
      break;
    case "F4":
      data = writeMovementsReport({
        id,
        searchValues: tempValues,
        responseReportData,
      });
      break;
    case "F5":
      data = writeMovementsBatches({
        id,
        searchValues: tempValues,
        responseReportData,
        itemsList,
      });
      break;
    case "F10":
    case "LOG":
      data = writeDataResults({
        id,
        searchValues: tempValues,
        responseReportData,
      });
      break;
  }
  return data;
};
